import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { OverviewContainer, OverviewHighlightText } from "./CommonViews";
export const CommonInfrastructureOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="OnboardingInfrastructureLearnMore">Infrastructure</ExternalLink> includes the environments, targets, workers and accounts that you will be deploying to. The infrastructure overview will help you keep track of
                    the health status and the types of deployment targets and workers you have.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
